module.exports = __webpack_public_path__ + "static/media/photo289.4fba3b94.jpg";